module.exports = __webpack_public_path__ + "static/media/2.010efdb7.gif";